(function () {
  'use strict';

  function initBackToTop() {
    var btn = document.createElement('button');
    btn.id = 'is-back-to-top';
    btn.setAttribute('aria-label', 'العودة للأعلى');
    btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 14V4M9 4L4 9M9 4L14 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    document.body.appendChild(btn);

    var ticking = false;

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        if (window.scrollY > 600) {
          btn.classList.add('is-btt-visible');
        } else {
          btn.classList.remove('is-btt-visible');
        }
        ticking = false;
      });
    }, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function injectStyles() {
    var style = document.createElement('style');
    style.textContent = [
      '#is-back-to-top{position:fixed;bottom:90px;right:20px;z-index:9998;width:46px;height:46px;border-radius:50%;background:#9e197e;border:2px solid #fff;cursor:pointer;display:flex;align-items:center;justify-content:center;opacity:0;transform:translateY(16px) scale(0.85);transition:opacity 0.3s ease,transform 0.3s ease;pointer-events:none;box-shadow:0 4px 16px rgba(158,25,126,0.35);}',
      '#is-back-to-top.is-btt-visible{opacity:1;transform:translateY(0) scale(1);pointer-events:auto;}',
      '#is-back-to-top:hover{background:#7d1464;transform:translateY(-2px) scale(1.05);}',
      '#is-back-to-top:active{transform:scale(0.96);}'
    ].join('');
    document.head.appendChild(style);
  }

  injectStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackToTop);
  } else {
    initBackToTop();
  }

})();